import * as sstat from 'simple-statistics';

export class Quantiles {
  static deserialize(s: string): Quantiles {
    const j = JSON.parse(s) as Array<[number, number]>;
    const keys = j.map(e => e[0]);
    const values = j.map(e => e[1]);
    const result = new Quantiles(new Set<number>(), []);
    result._fractionToValue.clear();

    for (const entry of keys.map((key, i) => ({key, value: values[i]}))) {
      result._fractionToValue.set(entry.key, entry.value);
    }

    return result;
  }

  readonly _fractionToValue = new Map<number, number>();

  constructor(keys: Set<number>, values: number[]) {
    /* eslint @typescript-eslint/require-array-sort-compare: "off" */
    const sorted = [...values].sort();

    // Explictly clarifying the type of this function saves us from a less
    // than tender embrace from xo/eslint.
    const quantileFunc = sstat.quantile as (a: number[], k: number) => number;

    for (const k of keys) {
      const q: number = quantileFunc(sorted, k);
      this._fractionToValue.set(k, q);
    }
  }

  serialize(): string {
    return JSON.stringify(
      [...this._fractionToValue.entries()].map(
        e => [e[0], e[1]],
      ),
    );
  }

  get keys(): number[] {
    return [...this._fractionToValue.keys()];
  }

  // Caution! This isn't necessarily meaninful a property without the keys.
  get values(): number[] {
    return [...this._fractionToValue.values()];
  }

  get(key: number): number | undefined {
    return this._fractionToValue.get(key);
  }
}

export const STANDARD_QUANTILES = new Set<number>([
  0.00, 0.01, 0.05, 0.10, 0.25, 0.50, 0.75, 0.90, 0.95, 0.99, 1.00,
]);
